import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';

const GetMarginByIdResponseDtoSchema = z.object({
  margin: z.object({
    currentPct: z.number().nullable(),
    changePct: z.number().nullable(),
  }),
  sparkline: z
    .object({
      granularity: z.string(),
      points: z.array(
        z.object({
          start: z.string(),
          end: z.string(),
          value: z.number(),
        })
      ),
    })
    .nullable(),
});

const _GetMarginByIdRequestDtoSchema = z.object({
  facilityId: z.string(),
  from: z.string(),
  to: z.string(),
});

export type GetMarginByIdResponseDto = z.infer<
  typeof GetMarginByIdResponseDtoSchema
>;
export type GetMarginByIdRequestDto = z.infer<
  typeof _GetMarginByIdRequestDtoSchema
>;

export const getMarginById = (
  params: GetMarginByIdRequestDto,
  config?: AxiosRequestConfig<GetMarginByIdRequestDto>
) => {
  return api
    .get(`facilities/${params.facilityId}/margin`, {
      params: { from: params.from, to: params.to },
      ...config,
    })
    .then(responseContract(GetMarginByIdResponseDtoSchema));
};
